import type { SVGProps } from "react";
export interface PenNibMinusIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PenNibMinusIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PenNibMinusIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.941 13.384a1.876 1.876 0 0 1-.192 3.741c-.09 0-.177-.01-.263-.021l-5.247 5.248a1.125 1.125 0 1 1-1.591-1.59l5.247-5.25q-.006-.034-.01-.07l-.01-.192.01-.191a1.875 1.875 0 0 1 1.864-1.684zm2.246-7.198a1.125 1.125 0 0 1 1.504-.078l.087.078 5.036 5.036.078.087a1.125 1.125 0 0 1-1.584 1.582l-.085-.078-5.036-5.036-.078-.085a1.125 1.125 0 0 1 .078-1.506M7 3.375l.115.006a1.125 1.125 0 0 1 0 2.238L7 5.625H2a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M15.858 3.574a3.126 3.126 0 0 1 4.182.215l2.172 2.17.214.238a3.126 3.126 0 0 1 0 3.945l-.214.237-1.964 1.965a6.88 6.88 0 0 0-1.837 3.315l-.557 2.412a4.13 4.13 0 0 1-3.14 3.103l-8.65 1.888c-1.869.407-3.532-1.256-3.125-3.125l1.887-8.651a4.13 4.13 0 0 1 3.102-3.14l2.413-.556a6.9 6.9 0 0 0 3.316-1.838l1.963-1.963.238-.216Zm2.59 1.806a.876.876 0 0 0-1.1-.113l-.137.113-1.963 1.963a9.13 9.13 0 0 1-4.4 2.439l-2.413.556a1.88 1.88 0 0 0-1.41 1.428l-1.887 8.65a.375.375 0 0 0 .445.447l8.652-1.887a1.88 1.88 0 0 0 1.426-1.41l.557-2.413a9.13 9.13 0 0 1 2.439-4.4l1.963-1.965.113-.137a.88.88 0 0 0 0-.963l-.113-.137z"
      />
    </svg>
  );
}
